import { render, staticRenderFns } from "./PCNewView.vue?vue&type=template&id=012ca759&scoped=true"
import script from "./PCNewView.vue?vue&type=script&lang=js"
export * from "./PCNewView.vue?vue&type=script&lang=js"
import style0 from "./PCNewView.vue?vue&type=style&index=0&id=012ca759&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ca759",
  null
  
)

export default component.exports